import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { eramanHost } from "~/Utils";
import { decodeHTML } from "~/Utils/CommonUtils";
import { useDutyFreeBuyingGuide } from "../../Pages.hook";
import { fields } from "../../constants";

export const AddEditDutyFreeBuyingGuide = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const {
    data: editData,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditData,
  } = useDutyFreeBuyingGuide(query.get("editId") || "");

  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchEditData();
    }
  }, [query.get("editId"), query.get("id")]);

  const DutyFreeBuyingGuideFormConfig: FormConfig = {
    initialValues: {
      title: decodeHTML(dataById ? dataById.payload.title : editData ? editData?.[0]?.title : ""),
      field_common_malay_title: decodeHTML(
        dataById ? dataById.payload.field_common_malay_title : editData ? editData?.[0]?.field_common_malay_title : ""
      ),
      field_common_mandarin_title: decodeHTML(
        dataById
          ? dataById.payload.field_common_mandarin_title
          : editData
            ? editData?.[0]?.field_common_mandarin_title
            : ""
      ),

      field_category_en: decodeHTML(
        dataById ? dataById.payload.field_category_en : editData ? editData?.[0]?.field_category_en : ""
      ),
      field_category_ms: decodeHTML(
        dataById ? dataById.payload.field_category_ms : editData ? editData?.[0]?.field_category_ms : ""
      ),
      field_category_zh: decodeHTML(
        dataById ? dataById.payload.field_category_zh : editData ? editData?.[0]?.field_category_zh : ""
      ),

      field_name_en: decodeHTML(
        dataById ? dataById.payload.field_name_en : editData ? editData?.[0]?.field_name_en : ""
      ),
      field_name_ms: decodeHTML(
        dataById ? dataById.payload.field_name_ms : editData ? editData?.[0]?.field_name_ms : ""
      ),
      field_name_zh: decodeHTML(
        dataById ? dataById.payload.field_name_zh : editData ? editData?.[0]?.field_name_zh : ""
      ),

      field_message_en: decodeHTML(
        dataById ? dataById.payload.field_message_en : editData ? editData?.[0]?.field_message_en : ""
      ),
      field_message_ms: decodeHTML(
        dataById ? dataById.payload.field_message_ms : editData ? editData?.[0]?.field_message_ms : ""
      ),
      field_message_zh: decodeHTML(
        dataById ? dataById.payload.field_message_zh : editData ? editData?.[0]?.field_message_zh : ""
      ),

      published: dataById
        ? String(dataById.payload?.published).toLowerCase() === "true"
        : editData
          ? String(editData?.[0]?.published).toLowerCase() === "true"
          : false,

      // field_airport: dataById
      //   ? dataById?.payload?.field_airport?.split(",")?.map((item: string) => item.trim())
      //   : editData
      //     ? editData?.[0]?.field_airport?.split(",")?.map((item: string) => item.trim())
      //     : [],
    },
    fields: fields.dutyFreeBuyingGuide,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = [
      "fbImage",
      "field_purchase_login_pop_image",
      "field_login_image",
      "filledImage",
      "googleImage",
      "showImage",
      "field_logout_image",
    ];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "ERAMAN");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }
    let arrayToStringKeys: any = ["field_airport"];
    for (const key of arrayToStringKeys) {
      try {
        if (Array.isArray(data[key])) {
          data[key] = data[key].join(", ");
        }
      } catch (error) {
        console.error("Error processing field_airport:", error);
      }
    }

    const payload = {
      action: action,
      method: method,
      module: "Pages",
      subModule: `travellersInfo_dutyFreeBuyingGuide`,
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editData?.[0]?.id || dataById?.payload?.id }),
        ...data,
      },
      status: status,
    };
    console.log(payload, "payload");
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingData}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Duty Free Buying Guide`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingData || drilldownLoading}
        config={DutyFreeBuyingGuideFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            query.get("editId") || query.get("type") === "update"
              ? `${eramanHost}/api/duty-free-buying-guide-crud-api/${editData?.[0]?.id || dataById?.payload?.id}`
              : `${eramanHost}/api/create/duty-free-buying-guide-crud-api`,
            `${query.get("editId") || query.get("type") === "update" ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") || query.get("type") === "update" ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </ContentWrapper>
  );
};
